export default "__VITE_ASSET__DuECBBU8__"